import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Agent } from "api/agent";

export const useGetAllCertificationClasses = (
  { pageNumber = -1, pageSize = -1 },
  options = {}
) => {
  return useQuery({
    queryKey: ["getAllCertificationClasses", pageNumber, pageSize],
    queryFn: () =>
      Agent.certificationClass.getAll({
        pageNumber: pageNumber,
        pageSize: pageSize,
      }),
    staleTime: 1000 * 60 * 60,
    ...options,
  });
};

export const useGetCertificationClassById = (id, options = {}) => {
  return useQuery({
    queryKey: ["getCertificationClassById", id],
    queryFn: () => Agent.certificationClass.getById(id),
    staleTime: 1000 * 60 * 10,
    ...options,
  });
};

export const useCreateCertificationClass = ({ config = {} }) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    mutationKey: ["createCertificationClass"],
    mutationFn: (body) => Agent.certificationClass.create(body),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ["getAllCertificationClasses"],
      });
      onSuccess?.(...args);
    },
    ...restConfig,
  });
};

export const useUpdateCertificationClass = ({ id, config = {} }) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    mutationKey: ["updateCertificationClass"],
    mutationFn: (body) => Agent.certificationClass.update(id, body),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ["getAllCertificationClasses"],
      });
      queryClient.invalidateQueries({
        queryKey: ["getCertificationClassById", id],
      });
      onSuccess?.(...args);
    },
    ...restConfig,
  });
};

export const useDeleteCertificationClass = ({ id, config = {} }) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    mutationKey: ["deleteCertificationClass"],
    mutationFn: () => Agent.certificationClass.delete(id),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ["getAllCertificationClasses"],
      });
      onSuccess?.(...args);
    },
    ...restConfig,
  });
};
